import { render } from "./MedicalGastroenterology.vue?vue&type=template&id=096bb064&scoped=true"
import script from "./MedicalGastroenterology.vue?vue&type=script&lang=ts"
export * from "./MedicalGastroenterology.vue?vue&type=script&lang=ts"

import "./MedicalGastroenterology.vue?vue&type=style&index=0&id=096bb064&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-096bb064"

export default script